import React from 'react';
import styled from 'styled-components';

import { Badge, type BadgeProps } from '@companycam/slab-web';

const getFontSize = (size: BadgeProps['size']) => {
  if (size === 'small') {
    return 16;
  }
  return 17;
};

const CircleBadge = styled(Badge)<{ size: BadgeProps['size'] }>`
  padding: 0;
  width: ${({ size }) => getFontSize(size)}px;
  height: ${({ size }) => getFontSize(size)}px;
  align-items: center;
`;

const Icon = styled.i<{ size: BadgeProps['size'] }>`
  font-size: ${(props) => getFontSize(props.size) - 3}px;
`;

type UpgradeIconProps = {
  size?: BadgeProps['size'];
  className?: string;
  style?: React.CSSProperties;
  dataTestId?: string;
};

const UpgradeIcon = ({
  size = 'medium',
  className,
  style,
  dataTestId,
}: UpgradeIconProps) => {
  return (
    <CircleBadge
      color="upgrade"
      className={className}
      size={size}
      style={{
        padding: 0,
        lineHeight: 0,
        height: getFontSize(size),
        width: getFontSize(size),
        ...style,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
    >
      <Icon size={size} className="mdi mdi-lightning-bolt upgrade-icon" />
    </CircleBadge>
  );
};

export default UpgradeIcon;
